import { Button, Card, InputField } from "components";
import { fieldLimits } from "config";
import { useFormikContext } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Paths from "routes/Paths";

import type { ForgotPasswordModel } from "../../models";

import EmailIcon from "./EmailIcon";

import styles from "../ForgotPassword.module.css";

const ForgotPasswordForm = () => {
	const { t } = useTranslation("accountsPage");
	const { isSubmitting } = useFormikContext<ForgotPasswordModel>();

	return (
		<Card className={styles.card}>
			<div className={styles.form}>
				<header className={styles.header}>
					<h1 className={styles.title}>{t("forgotPassword.title")}</h1>
					<p className={styles.subtitle}>{t("forgotPassword.subtitle")}</p>
				</header>
				<div className={styles.body}>
					<InputField
						autoComplete="email"
						label={t("forgotPassword.emailLabel")}
						leftAccessory={<EmailIcon />}
						maxLength={fieldLimits.email}
						name="email"
						placeholder={t("forgotPassword.emailPlaceholder")}
						type="email"
					/>
				</div>
				<footer className={styles.footer}>
					<Button className={styles.submitButton} disabled={isSubmitting} type="submit" fullWidth>
						{t("forgotPassword.submit")}
					</Button>
					<Link className={styles.backLink} to={Paths.signIn}>
						{t("forgotPassword.backToSignIn")}
					</Link>
				</footer>
			</div>
		</Card>
	);
};

export default ForgotPasswordForm;
